import { css } from 'styled-components';

const themeFactory = (colors, tokens) => {
    return {
        colors,
        tokens,
        fonts: {
            museo: 'Museo Sans Cyrl, sans-serif',
        },
        fontSizes: {
            10: '10px',
            12: '12px',
            14: '14px',
            16: '16px',
            20: '20px',
            24: '24px',
            28: '28px',
            32: '32px',
            40: '40px',
            56: '56px',
            64: '64px',
        },
        utils: {
            box: value => css `
        width: ${value}px;
        height: ${value}px;
      `,
        },
    };
};

export { themeFactory };
//# sourceMappingURL=utils.js.map
